var Backbone = require('backbone');
var $ = require('jquery');
var polyglot = require('../../utilities/polyglot').default;

var KEYCODES = require('../../utilities/keycodes').default;

export default Backbone.View.extend({

  tagName: 'div',
  className: 'location-search',
  events: {
    'keyup .location-search-box': 'onKeyUp',
    'click .location-search-icon': 'onClickIcon',
    'click .location-search-link': 'onClickLink',
  },

  render: function () {
    var container = $('<div class="location-search-container"></div>').appendTo(this.$el);
    const form = $('<form action="#"></form>').appendTo(container);
    form.on('submit', e => e.preventDefault());

    this.$input = $(`<input class="location-search-box" type="search" aria-label="location-search" id="location-search" placeholder="${polyglot.t('location.search_placeholder')}">`).appendTo(form);
    this.$icon = $('<button class="location-search-icon fa fa-search" type="button" role="button" aria-label="Search"></button>').appendTo(container);
    container.appendTo(this.$el);

    if ('geolocation' in navigator) {
      $('<a href="#" class="location-search-link fa fa-crosshairs" aria-label="Use my location"></a>').appendTo(container);
    }

    return this;
  },

  focus: function () {
    this.$input.focus();
  },

  onKeyUp: function (evt) {
    const input = this.$input.val();

    if (evt.keyCode === KEYCODES.ENTER) {
      this.trigger('search', input);

      return;
    }

    this.trigger('search-suggest', input);
  },

  onClickIcon: function (evt) {
    evt.preventDefault();
    this.trigger('search', this.$input.val());
  },

  onClickLink: function (evt) {
    evt.preventDefault();
    this.trigger('search-by-location');
  },

  onGeoLocationSuccess: function () {
    $('.l-location-step-error').html('');
  },

  onGeoLocationError: function () {
    $('.l-location-step-error').html('<div class="location-search-message"><span class="fa fa-warning location-search-warning-icon"></span><span> ' + polyglot.t('location.unable_to_retrieve') + '</span></div>');
    window.setTimeout(() => {
      $('.l-location-step-error').empty();
      this.trigger('dismissError');
    }, 5000);
  },

});
